let instance = null;
class SecVote {
    constructor(){
        if(instance) return instance;
        this.section3 = document.getElementById("section-3");
        instance = this;
    }

    vote_on(){
        this.section3.classList.remove("p-sec3-2");
        this.section3.classList.add("p-sec3");
        this.section3.querySelector(".p-ranking--off") && this.section3.querySelector(".p-ranking--off").remove();
    }

    vote_off(){
        this.section3.classList.remove("p-sec3");
        this.section3.classList.add("p-sec3-2");
        this.section3.querySelector(".p-ranking--on") && this.section3.querySelector(".p-ranking--on").remove();
    }
}

export default SecVote;


// WEBPACK FOOTER //
// ./src/js/func/change_sec3.js